import React from "react";

function VideoPlayer({ videoUrl, challengeTitle, onMarkComplete, isSubmitting }) {
  // Extract YouTube video ID from URL
  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = getYouTubeId(videoUrl);

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Video Embed */}
        <div className="aspect-video bg-zinc-900 rounded-xl border border-zinc-800 overflow-hidden mb-6">
          {videoId ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}`}
              title={challengeTitle}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <svg className="w-16 h-16 text-zinc-600 mx-auto mb-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                </svg>
                <p className="font-display text-zinc-500">Video not available</p>
              </div>
            </div>
          )}
        </div>

        {/* Mark as Watched Button */}
        <div className="text-center">
          <button
            onClick={onMarkComplete}
            disabled={isSubmitting}
            className="bg-emerald-600 hover:bg-emerald-500 disabled:bg-zinc-700 disabled:cursor-not-allowed text-white font-display font-medium px-6 py-3 rounded-lg transition-colors"
          >
            {isSubmitting ? "Saving..." : "Mark as Watched"}
          </button>
          <p className="text-zinc-500 text-sm mt-3">
            Watch the full video before marking as complete
          </p>
        </div>
      </div>
    </div>
  );
}

export default VideoPlayer;
